import { useEffect, useRef } from 'react';

import useAuthStore from '~/stores/auth/useAuthStore';
import { useFeatureFlagStore } from '~/stores/featureFlags/useFeatureFlagStore';

export const useFeatureFlagsInit = () => {
  const hasInitialized = useRef(false);
  const { fetchFeatureFlags, isLoading, isSuccessful } = useFeatureFlagStore();
  const { tokenClaim } = useAuthStore();

  useEffect(() => {
    if (!hasInitialized.current && !isLoading && !isSuccessful) {
      hasInitialized.current = true;
      fetchFeatureFlags(tokenClaim?.email);
    }
  }, [fetchFeatureFlags, isLoading, isSuccessful, tokenClaim?.email]);
};
